import React from 'react'
import { PlacementSummary } from '../../../services/api'
import VideoEmbedPreview from './VideoEmbedPreview'
import EditorialPreview from './EditorialPreview'
import BannerImagePreview from './BannerImagePreview'
import pvStyles from '../PagePreview.module.scss'

// Dispatcher — keep the cases in sync with apps/cms/src/constants/widgetTypes.ts
// and the widget_type CHECK constraint in shared/migrations.
const WidgetPreview: React.FC<{ placement: PlacementSummary }> = ({ placement }) => {
  const widgetType = placement.widget?.widget_type
  switch (widgetType) {
    case 'video_embed':
      return <VideoEmbedPreview placement={placement} />
    case 'editorial':
      return <EditorialPreview placement={placement} />
    case 'banner_image':
      return <BannerImagePreview placement={placement} />
    default:
      return (
        <div className={pvStyles.pvWidgetPlaceholder}>
          <span className={pvStyles.pvPlaceholderIcon}>❔</span>
          <span>No preview for widget type: {widgetType || 'unknown'}</span>
        </div>
      )
  }
}

export default WidgetPreview
